/* eslint-disable */

Date.prototype.getDayOfWeek = function(number){
  return ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"][number];
};